module.exports = __webpack_public_path__ + "img/asset_RAY-USDC.5b6cc9d4.png";